import { render, staticRenderFns } from "./HeaderBadge.vue?vue&type=template&id=1813ee2c"
import script from "./HeaderBadge.vue?vue&type=script&lang=js"
export * from "./HeaderBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports